/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplatePlanRequest extends models.TemplateExecutionRequestBase {
    getFixupPrototypeFunction() { return TemplatePlanRequest.fixupPrototype; }

    static newInstance(model: Partial<TemplatePlanRequest>): TemplatePlanRequest {
        let obj = Object.assign(new TemplatePlanRequest(), model);
        TemplatePlanRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplatePlanRequest>): TemplatePlanRequest {
        if (!model) return null;
        return TemplatePlanRequest.newInstance(<TemplatePlanRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplatePlanRequest) {
        if (!obj) return;

        models.TemplatePlanRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplatePlanRequest): boolean {
        if (models.TemplateExecutionRequestBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TemplatePlanRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
